"use client";
import { ConfigProvider, theme, ThemeConfig } from "antd";
import { ReactNode, useMemo } from "react";
import fontFamilies from "src/styles/fontFamilies";

const ThemeProvider = ({ children }: { children: ReactNode }) => {
	const configTheme = useMemo<ThemeConfig>(() => {
		return {
			algorithm: theme.darkAlgorithm,
			components: {
				Layout: {
					siderBg: "#121212",
				},
				Menu: {
					darkItemBg: "#121212",
					darkSubMenuItemBg: "#1E1E1E",
				},
			},
			token: {
				// All web font families are the same
				fontFamily: fontFamilies.regular,
			},
		};
	}, []);

	return <ConfigProvider theme={configTheme}>{children}</ConfigProvider>;
};
export default ThemeProvider;
